module.exports = __webpack_public_path__ + "static/media/opt-in.b4b44463.svg";